export default __webpack_public_path__ + "static/media/CarBlack.c821ff7b.png";